import { useCallback } from "react"
import { View, ViewStyle } from "react-native"

import { useFocusEffect } from "expo-router"
import * as ScreenOrientation from "expo-screen-orientation"
import { useSafeAreaInsets } from "react-native-safe-area-context"

import { LLMListMenu } from "src/components/LLMListMenu"
import { useAppTheme } from "src/hooks/useAppTheme"
import { ThemedStyle } from "src/theme"

export default function LLMSelectionScreen() {
  const safeInsets = useSafeAreaInsets()
  const { themed } = useAppTheme()

  // Lock to portrait orientation when this screen gains focus
  useFocusEffect(
    useCallback(() => {
      ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT_UP).catch(() => {})
    }, []),
  )

  return (
    <View style={{ ...$flex, marginTop: safeInsets.top, marginBottom: safeInsets.bottom }}>
      <View style={themed($container)}>
        <View style={themed($menu)}>
          <LLMListMenu />
        </View>
      </View>
    </View>
  )
}

const $flex: ViewStyle = { flex: 1 }

const $container: ThemedStyle<ViewStyle> = ({ colors }) => ({
  flex: 1,
  backgroundColor: colors.background,
})

const $menu: ThemedStyle<ViewStyle> = ({ spacing }) => ({
  padding: spacing.md,
})
